// = Libs =
import { components } from 'react-select';

// = Components =
import Icon from '@/common/components/ui/icon/icon';

// = Types =
import { SelectDropdownIndicatorProps } from './select-dropdown-indicator.types';

const SelectDropdownIndicator = (
  props: SelectDropdownIndicatorProps & { addClass?: string }
) => {
  return (
    <components.DropdownIndicator {...props} className={props.addClass}>
      <Icon type={props.iconType || 'dropdown'} color="primary" />
    </components.DropdownIndicator>
  );
};

export default SelectDropdownIndicator;
